/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateAndMountVirtualPrimaryContainerEntry } from '../../models/create-and-mount-virtual-primary-container-entry';

export interface CreateAndMountVirtualPrimaryContainer$Params {
  workCenterId: number;
      body: CreateAndMountVirtualPrimaryContainerEntry
}

export function createAndMountVirtualPrimaryContainer(http: HttpClient, rootUrl: string, params: CreateAndMountVirtualPrimaryContainer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, createAndMountVirtualPrimaryContainer.PATH, 'post');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

createAndMountVirtualPrimaryContainer.PATH = '/api/v1/PrimaryMaterial/{workCenterId}/CreateAndMountVirtualPrimaryContainer';
